module.exports = __webpack_public_path__ + "static/media/mayonnaise.90aa25c5.jpg";